import { z } from 'zod';
export const FlowEdgeSchema = z.object({
    source: z.string(),
    target: z.string(),
    condition: z
        .string()
        .optional()
        .describe('When an edge is from a Condition to a block, it defines the path for the condition value it represents'),
    isError: z.boolean().optional().describe('True when an edge exists as the error path'),
});
//# sourceMappingURL=edges.js.map